import {FormInfo, SectionInfo} from './consts';
import * as _ from 'lodash';

export default function fieldsToSections<FormData extends object = {}>({
  fields,
  sections,
}: FormInfo): SectionInfo<FormData>[] {
  const fieldsBySection = _.groupBy(_.filter(fields, 'section'), 'section');
  return _.map(
    sections,
    (sectionName): SectionInfo<FormData> => {
      return {fieldsInfo: _.orderBy(fieldsBySection[sectionName], 'order', 'asc'), name: sectionName};
    }
  );
}
